import { call, put, select, takeLatest } from "redux-saga/effects"
import actionTypes from "../../actions/actionTypes"
import { FLYER_DATA, PROGRAM_CLI_MOVIES_ITEMS, CLI_CURRENT_CINEMA_ID, CLI_MULTICINEMA_MODE, PRINT_TYPES_DATA } from "../../constants/state";
import getData from "../../functions/getData";
import { GRID_IMAGE, MOVIE, MOVIE_PERFORMANCES } from "../../constants/itemTypes";
import chooseCinemasActive from "../../components/PageWebToPrint/functions/chooseCinemasActive";


const getPrintMoviesData = state => ({
    flyerData: getData(state, FLYER_DATA).toJS(),
    moviesItems: getData(state, PROGRAM_CLI_MOVIES_ITEMS).toJS(),
    currentCinemaId: getData(state, CLI_CURRENT_CINEMA_ID),
    multicinemaMode: getData(state, CLI_MULTICINEMA_MODE),
    printTypesData: getData(state, PRINT_TYPES_DATA).toJS()
})



function* deleteFlyerElement(itemId, section) {
    yield put({
        type: actionTypes.PRINT_LOCAL_DATA_FLYER_DELETE_FLYER_ELEMENT,
        meta: {},
        payload: {
            section: section,
            itemId: itemId,
        }
    })
}

function* deleteFlyerStructureItem(side, section, area, movieId) {
    yield put({
        type: actionTypes.PRINT_LOCAL_DATA_FLYER_DELETE_FLYER_STRUCTURE_ITEM,
        meta: {},
        payload: {
            side: side,
            section: section,
            area: area,
            itemId: movieId,
            
        }
    })
}
function* printToolDeleteItem (printType, printFormat, landscape, itemId) {
    yield put({
    type: actionTypes.PRINT_TOOL_DELETE_ITEM,
    payload: {
        printType: printType,
        printFormat: printFormat,
        landscape: landscape,
        itemId: itemId
    }
})}

function* deleteFromSection(side, section, area, data, flyerData, moviesItems, currentCinemaId) {
    const order = yield data.order 
    const items = yield data.items
    
    for(let i = 0; i < order.length; i++) {
        const itemId = yield order[i]
        const itemType = yield items[itemId].type

        let movieId = yield false

        if(GRID_IMAGE === itemType ) {
            const gridImage = yield flyerData.gridImages.items[itemId]

            if(MOVIE === gridImage.itemType) {
                movieId = yield gridImage.itemId
            }

        } else if(MOVIE_PERFORMANCES === itemType) {
            movieId = yield flyerData.moviePerformances.items[itemId].movieId
        }

        if(movieId) {
            const movieExist = yield moviesItems.hasOwnProperty(movieId) && (!currentCinemaId || moviesItems[movieId].cinemaIds.includes(currentCinemaId))

            if(!movieExist) {
                yield call(deleteFlyerStructureItem, side, section, area, itemId)

                if(MOVIE_PERFORMANCES === itemType) {
                    yield call(deleteFlyerElement, itemId, 'moviePerformances')
                } else if(GRID_IMAGE === itemType) {
                    yield call(deleteFlyerElement, itemId, 'gridImages')
                }
            }
        }
    }
}


function* deleteFromFlyerStructure(flyerData, moviesItems, currentCinemaId) {
    const flyerStructure = yield flyerData.flyerStructure
    const pageKeys = yield Object.keys(flyerStructure)

    for(let p = 0; p < pageKeys.length; p++) {
        const pageKey = yield pageKeys[p]
        const sectionKeys = yield Object.keys(flyerStructure[pageKey])

        for(let s = 0; s < sectionKeys.length; s++) {
            const sectionKey = yield sectionKeys[s]
            const sectionData = yield flyerStructure[pageKey][sectionKey]

            if(sectionData.hasOwnProperty('order')) {
                yield call(deleteFromSection, pageKey, sectionKey, false, sectionData, flyerData, moviesItems, currentCinemaId)
            } else {
                yield call(deleteFromSection, pageKey, sectionKey, 'grid', sectionData.grid, flyerData, moviesItems, currentCinemaId)
                yield call(deleteFromSection, pageKey, sectionKey, 'content', sectionData.content, flyerData, moviesItems, currentCinemaId)
            }
        }
    }
}

function* deleteFromStructure(printData, moviesItems, currentCinemaId, printDataKey) {
    const printFormats = yield printData.allFormats
    const formatKeys = yield Object.keys(printFormats)
    for(let p = 0; p < formatKeys.length; p++) {
        const formatKey = yield formatKeys[p]
        const items = yield printFormats[formatKey].items

        for(let i = 0; i < items.length; i++) {
            const movieId = items[i]
            if(movieId) {
                const movieExist = yield moviesItems.hasOwnProperty(movieId) && (!currentCinemaId || moviesItems[movieId].cinemaIds.includes(currentCinemaId))
                const format = formatKey.search("landscape") !== -1 ? formatKey.replace('landscape','') : formatKey.replace('portrait','')
                const landscape = formatKey.search("landscape") !== -1 ? 'true' : 'false'

                if(!movieExist) {
                    yield call(printToolDeleteItem, printDataKey, format, landscape, movieId)
                }
            }
        }
    }
}


function* filterData(payload) {
    try {
        const { flyerData, moviesItems, currentCinemaId, multicinemaMode, printTypesData } = yield select(getPrintMoviesData)
        const showcaseData = printTypesData ? printTypesData.showcase : null
        const weekposterData = printTypesData ? printTypesData.weekposter : null

        let currentCinema = yield null

        if(payload && payload.hasOwnProperty('payload') && payload.payload.hasOwnProperty('cinemaId')) {
            currentCinema = yield payload.payload.cinemaId
        } else if(chooseCinemasActive(multicinemaMode)) {
            currentCinema = yield false
        } else {
            currentCinema = yield currentCinemaId
        }

        yield call(deleteFromFlyerStructure, flyerData, moviesItems, currentCinema)
        yield call(deleteFromStructure, showcaseData, moviesItems, currentCinema, 'showcase')
        yield call(deleteFromStructure, weekposterData, moviesItems, currentCinema, 'weekposter')

        yield put({
            type: actionTypes.PRINT_DATA_FILTER_SUCCESS, 
        })
    } catch(e) {
        yield put({
            type: actionTypes.PRINT_DATA_FILTER_ERROR, 
        })
    }
}


function* watchPrintFilterData() {
    //ToDo: Use only PRINT_DATA_FILTER_REQUEST
    yield takeLatest([actionTypes.PRINT_DATA_FILTER_REQUEST, actionTypes.PRINT_DATA_GET_SUCCESS, actionTypes.PROGRAM_FETCH_SUCCESS], filterData)
}

export default watchPrintFilterData